import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageCreateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchPageCreate = createAsyncThunk(
    'pageCreate/fetchPageCreate',
    async ({ slug, title, description, formID, pageType }) => {
        const response = await PageCreateService(slug, title, description, formID, pageType)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const pageCreateSlice = createSlice({
    name: 'pageCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageCreateSlice.reducer;
